// Fields that only exist for the form, but will not be sent to the API.
enum TemporaryField {
  BIRTHDAY = '_birthday',
  LABELS = '_labels',
  UPLOAD_IDS = '_uploadIds',
}

export default TemporaryField;
